import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Timesheet from '../../../Components/pages/timesheet/Timesheet';
import classes from './TimesheetPage.module.scss';
import { getTimesheet } from '../../../actions/timesheet';
import { generalEnums } from '../../../utils/enums';
import { PageContext } from '../../../context/context';
import LoadingWithSpinner from '../../../Components/common/LoadingWithSpinner/LoadingWithSpinner';

export default function TimesheetPage() {
  const params = useParams();
  const dispatch = useDispatch();
  const timesheet = useSelector((state) => state.timesheet.data);
  const ctx = useContext(PageContext);

  useEffect(() => {
    ctx.setPageType(generalEnums.TIMESHEET);
  }, [params, generalEnums, ctx]);

  useEffect(() => {
    dispatch(getTimesheet(params?.id, localStorage.getItem('UserId')));
  }, []);

  return (
    <section className={classes.pageContainer}>{timesheet?.Status ? <Timesheet /> : <LoadingWithSpinner />}</section>
  );
}
